import { DateTime } from 'luxon';
import { getOrgTimezone } from '@/data/organization';

// Reporting ranges are org-local calendar days. Pages keep dates as plain
// day containers: a JS Date at device-local midnight of the intended
// (org-local) calendar day, or a 'yyyy-MM-dd' string.

// Convert a luxon DateTime into a day-container Date (device-local midnight
// of that DateTime's calendar day)
export const dayContainer = (dt) => DateTime.fromISO(dt.toISODate()).toJSDate();

// Any range input -> 'yyyy-MM-dd'
export const toReportDay = async (input) => {
    if (!input) return null;
    if (input instanceof Date) return DateTime.fromJSDate(input).toISODate();
    const s = String(input);
    if (!s.includes('T')) return s;
    const tz = await getOrgTimezone();
    return DateTime.fromISO(s).setZone(tz).toISODate();
};

// 'yyyy-MM-dd' -> instant bounds in the org timezone (for timestamptz RPC params)
export const reportDayStartISO = (day, tz) => DateTime.fromISO(day, { zone: tz }).startOf('day').toISO();
export const reportDayEndISO = (day, tz) => DateTime.fromISO(day, { zone: tz }).endOf('day').toISO();

// Range inputs -> { start, end } org-timezone day-boundary instants
// (for timestamptz RPC params / instant column filters). Null-safe.
export const reportRangeBounds = async (startDate, endDate) => {
    const tz = await getOrgTimezone();
    const start = await toReportDay(startDate);
    const end = await toReportDay(endDate);
    return {
        start: start ? reportDayStartISO(start, tz) : null,
        end: end ? reportDayEndISO(end, tz) : null,
    };
};
